// extracted by mini-css-extract-plugin
module.exports = {"root":"HotelSelect_root__1ENlg","select":"HotelSelect_select__1u8aS"};